<template>
  <div class="not-found">
    <p>Not Found 😭</p>
  </div>
</template>
